<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="p-4">
      <b-button variant="info" block class="mb-4" v-b-modal.newContentTemplateNameModal>Crear nuevo template</b-button>
      <template v-if="contentTemplateOptions.length || contentTemplate">
        <h6>Templates creados</h6>
        <LmTextInput
          v-model="contentTemplateFilter"
          placeholder="Buscar template ..."
        />
        <b-list-group>
          <b-list-group-item
            v-if="contentTemplate"
            class="d-flex justify-content-between align-items-center"
            variant="secondary"
          >
            {{ contentTemplate.name }}
            <div>
              <span class="clickable text-primary" v-b-modal.updateContentTemplateNameModal>Actualizar</span>
              <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none p-0 ml-2" no-caret>
                <template #button-content>
                  <i class="mdi mdi-dots-vertical"></i>
                </template>
                <b-dropdown-item-button variant="danger" @click="onDeleteTemplate(contentTemplate)">Eliminar</b-dropdown-item-button>
              </b-dropdown>
            </div>
          </b-list-group-item>
          <b-list-group-item
            v-for="item in contentTemplateOptionsFiltered"
            :key="item.id"
            button
            @click.self="onContentTemplateChange(item)"
            class="d-flex justify-content-between align-items-center"
          >
            {{ item.name }}
            <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none p-0" no-caret>
              <template #button-content>
                <i class="mdi mdi-dots-vertical"></i>
              </template>
              <b-dropdown-item-button variant="danger" @click="onDeleteTemplate(item)">Eliminar</b-dropdown-item-button>
            </b-dropdown>
          </b-list-group-item>
        </b-list-group>
      </template>
      <div v-if="!contentTemplateOptions.length && !contentTemplate" class="mt-4">
        <LmSvgIcon
          wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
          width="6em"
          icon="LmNoDataIcon"
          text="No hay templates creados."
        />
      </div>
    </div>
    <b-modal
      centered
      id="newContentTemplateNameModal"
      @ok="onSaveTemplate('new')"
      title="Nuevo template de contenido"
      :cancel-title="$t('cancel')"
      :ok-title="$t('save')"
    >
      <LmTextInput
        class="col-auto px-0 pb-2"
        v-model="contentTemplateName"
        :label="$t('name')"
        :placeholder="$t('template_reference_name')"
      />
    </b-modal>
    <b-modal
      centered
      id="updateContentTemplateNameModal"
      @ok="onSaveTemplate('update')"
      title="Actualizar template de contenido"
      :cancel-title="$t('cancel')"
      :ok-title="$t('save')"
    >
      <LmTextInput
        class="col-auto px-0 pb-2"
        v-model="contentTemplateName"
        :label="$t('name')"
        :placeholder="$t('template_reference_name')"
      />
    </b-modal>
  </div>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    template: {
      type: Object
    },
    reference: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      contentTemplate: null,
      contentTemplateOptions: [],
      contentTemplateName: '',
      contentTemplateFilter: ''
    }
  },
  computed: {
    contentTemplateOptionsFiltered () {
      return this.contentTemplateOptions.filter(opt => {
        if (this.contentTemplateFilter === '') {
          return true
        } else {
          return opt.name.toLowerCase().search(this.contentTemplateFilter.toLowerCase()) !== -1
        }
      })
    }
  },
  methods: {
    async setContentTemplateOptions () {
      let options = await commonsApi.getSelectOptions({
        path: this.path
      })
      if (this.contentTemplate) {
        options = options.filter(el => el.id !== this.contentTemplate.id)
      }
      this.contentTemplateOptions = options
    },
    async onContentTemplateChange (template) {
      if (template) {
        this.contentTemplate = template
        this.contentTemplateName = template.name

        const res = await commonsApi.axiosGetWrapper(`/contenttemplate/${template?.id}`)
        this.$emit('onContentTemplateChange', res.data.template)
        await this.setContentTemplateOptions()
      }
    },
    // Funcion que guarda el contenido de this.form como content template o actualiza un template ya creado
    async onSaveTemplate (action) {
      try {
        let res = null
        if (action === 'new') {
          // Creo un nuevo template
          res = await commonsApi.axiosPostWrapper('/contenttemplate', {
            name: this.contentTemplateName,
            ref: this.reference,
            template: this.template
          })
          this.lmToastSuccessMessage(`Se creó el template ${this.contentTemplateName}.`, `Operación realizada con éxito.`)
        } else if (action === 'update') {
          // Actualizo un template
          res = await commonsApi.axiosPutWrapper(`/contenttemplate/${this.contentTemplate?.id}`, {
            name: this.contentTemplateName,
            ref: this.reference,
            template: this.template
          })
          this.lmToastSuccessMessage(`Se actualizó el template ${this.contentTemplateName}.`, `Operación realizada con éxito.`)
        }

        // Cargo el template creado o actualizado como seleccionado en el super power
        if (res) {
          this.contentTemplate = {
            id: res.data?._id || res.data?.id,
            name: res.data?.name,
            ref: res.data?.ref
          }
        }
        await this.setContentTemplateOptions()
      } catch (error) {
        console.log(error)
      }
    },
    async onDeleteTemplate (template) {
      try {
        if (template?.id) {
          await commonsApi.axiosDeleteWrapper(`/contenttemplate/delete/${template.id}`)
          this.lmToastSuccessMessage(`Se eliminó el template ${this.contentTemplateName}.`, `Operación realizada con éxito.`)
          await this.setContentTemplateOptions()
          if (template.id === this.contentTemplate.id) {
            this.contentTemplate = null
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    try {
      await this.setContentTemplateOptions()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
